<template>
  <div class="rule_content">

    <div v-if="clazzType===1" class="table-responsive">
      <table class="table table-striped">
        <thead>
          <tr>
            <th>周数</th>
            <th>周一</th>
            <th>周二</th>
            <th>周三</th>
            <th>周四</th>
            <th>周五</th>
            <th>周六</th>
            <th>周日</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in ruleList" :key="index">
            <th scope="row">{{ item.index }}</th>
            <td>{{ item.mon | ruleTitle }}</td>
            <td>{{ item.tues | ruleTitle }}</td>
            <td>{{ item.wed | ruleTitle }}</td>
            <td>{{ item.thur | ruleTitle }}</td>
            <td>{{ item.fri | ruleTitle }}</td>
            <td>{{ item.sat | ruleTitle }}</td>
            <td>{{ item.sun | ruleTitle }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-if="clazzType===2" class="table-responsive">
      <table class="table table-striped table-bordered">
        <thead>
          <tr>
            <th>周数</th>
            <th>早餐</th>
            <th>午餐</th>
            <th>晚餐</th>
            <th>加餐</th>
            <th>跑步训练</th>
            <th>技术/力量训练</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in ruleList" :key="index">
            <th scope="row">{{ item.index }}</th>
            <td>{{ item | breakfastTitle }}</td>
            <td>{{ item | lunchTitle }}</td>
            <td>{{ item | dinnerTitle }}</td>
            <td>{{ item | extraTitle }}</td>
            <td>{{ item | runTitle }}</td>
            <td>{{ item | trainTitle }}</td>
          </tr>
        </tbody>
      </table>
    </div>

  </div>
</template>

<script>

export default {
  name: 'RuleContent',
  components: {
  },
  filters: {
    ruleTitle (value) {
      if (value.ruleType === 1) {
        if (value.distance) {
          return value.distance + '公里'
        }
      } else if (value.ruleType === 2) {
        return '技术/力量训练'
      } else if (value.ruleType === 3) {
        return '休息'
      }
      return ''
    },
    breakfastTitle (value) {
      return value.breakfast + '次'
    },
    lunchTitle (value) {
      return value.lunch + '次'
    },
    dinnerTitle (value) {
      return value.dinner + '次'
    },
    extraTitle (value) {
      return value.extra + '次'
    },
    runTitle (value) {
      if (!value.run.num || !value.run.time) {
        return '0次'
      }
      return value.run.num + '次' + '（每次' + value.run.time + '分钟）'
    },
    trainTitle (value) {
      if (!value.train.num || !value.train.time) {
        return '0次'
      }
      return value.train.num + '次' + '（每次' + value.train.time + '分钟）'
    }
  },
  props: {
    clazzType: {
      type: Number
    },
    rule: {
      type: Object
    }
  },
  data () {
    return {
      ruleList: []
    }
  },
  created () {
    this.ruleList = this.rule.ruleList || []
  },
  methods: {
  }
}
</script>

<style scoped lang="scss">
.rule_content {
  font-size: 28px;
  // padding: 0 0 10px 0;
}
table {
  border-spacing: 0;
  border-collapse: collapse;
}
.table-striped>tbody>tr:nth-of-type(odd) {
    background-color: #f9f9f9;
}
.table-responsive {
  min-height: .01%;
  overflow-x: auto;
  thead {
    th {
      border-bottom: 1px solid #ddd;
    }
  }
  thead, tbody {
    th, td {
      padding: 20px 15px;
    }
  }
}
@media screen and (max-width: 767px) {
  .table-responsive {
    width: 100%;
    margin-bottom: 15px;
    overflow-y: hidden;
    -ms-overflow-style: -ms-autohiding-scrollbar;
    .table {
      margin-bottom: 0;
      tbody, tfoot, thead {
        td, th {
          white-space: nowrap;
        }
      }
    }
  }
}
</style>
